export const CLIENT_RELATIONSHIP_MANAGER = {
    szymanski: {
        en: 'Brandi Szymanski',
        es: 'Brandi Szymanski'
    },
    knee: {
        en: 'Danny Knee',
        es: 'Danny Knee'
    },
    nelson: {
        en: 'Caroline Nelson',
        es: 'Caroline Nelson'
    },
    banuelos: {
        en: 'Irasema Banuelos',
        es: 'Irasema Banuelos'
    },
    henry: {
        en: 'Nick Henry',
        es: 'Nick Henry'
    },
    burgess: {
        en: 'Carol Burgess',
        es: 'Carol Burgess'
    },
    caine: {
        en: 'Kerri Caine',
        es: 'Kerri Caine'
    },
    celaya: {
        en: 'Albert Celaya',
        es: 'Albert Celaya'
    },
    quijada: {
        en: 'Brian Quijada',
        es: 'Brian Quijada'
    },
    simmons: {
        en: 'Lori Simmons',
        es: 'Lori Simmons'
    },
    valenzuela: {
        en: 'Frank Valenzuela',
        es: 'Frank Valenzuela'
    }
} as Record<string, { en: string; es: string }>;
